import instance from "@/services/api";

export const bimParamsAPI = {
  async getList() {
    return await instance().get('/handbook/bim_params/read/').then(res => res?.data)
  },
  async save(data) {
    return await instance().post('/handbook/bim_params/save/', data).then(res => res?.data)
  },
  async delete(bim_param_id) {
    return await instance().delete(`/handbook/bim_params/${bim_param_id}/delete/`).then(res => res?.data)
  },
  async getBufferProperties() {
    return await instance().get('/handbook/bim_params/buffer_properties/read/').then(res => res?.data)
  }
}

